class Loader {
  constructor(target = 'body') {
    this.target = typeof target === 'string' ? document.querySelector(target) : target;
    if (!this.target) this.target = document.body;
    if (this.target.querySelector('.inline-loader')) {
      this.loader = this.target.querySelector('.inline-loader');
      return;
    }

    // Create loader element
    this.loader = document.createElement('div');
    this.loader.classList.add('inline-loader');
    // Ensure target is relative for absolute positioning
    const computed = getComputedStyle(this.target);
    if (computed.position === 'static') {
      this.target.style.position = 'relative';
    }
    this.target.appendChild(this.loader);
    // Add keyframes once
    if (!document.getElementById('inline-loader-style')) {
      const style = document.createElement('style');
      style.id = 'inline-loader-style';
      style.textContent = `
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `;
      document.head.appendChild(style);
    }
  }

  show() {
    this.loader.style.display = 'block';
    this.target.style.opacity = '0.5'; 
    this.target.disabled = true;
  }

  hide() {
    this.loader.style.display = 'none';
    this.target.style.opacity = '1'; 
    this.target.disabled = false;
  }
}

// Optional: helper to quickly create loader on an element
window.createLoader = (element) => new Loader(element);
